var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8 6.03l-3.7-3.7c-.23-.2-.52-.33-.83-.33-.3 0-.6.12-.83.34-.22.22-.34.5-.34.82 0 .3.12.6.34.82L6.5 8l-3.86 4.02c-.45.45-.45 1.2 0 1.64.22.22.52.34.83.34.3 0 .6-.12.82-.34L8 9.96l3.7 3.7c.23.22.52.34.83.34.3 0 .6-.12.83-.34.45-.45.45-1.2 0-1.64L9.5 8l3.86-4.02c.22-.22.34-.5.34-.82 0-.3-.12-.6-.34-.82-.22-.22-.52-.34-.83-.34-.3 0-.6.12-.82.34L8 6.04z"}));
}

Close.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Close;

Close.default = Close;
